import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Auth/renovarLicencia`, method: 'POST', body: values, token: token})
}